module.exports = __webpack_public_path__ + "static/product-bd575ef536df7b480072526b412e08c0.png";